import Box from '../Box';
import Grid from '../Grid';
import { useThemeDefaults } from '../utils';
var SideNav = useThemeDefaults(function () {
  return {
    gridTemplateColumns: ['minmax(0, 1fr)', 'minmax(0, 1fr)', '210px minmax(0, 1fr)'],
    gridColumnGap: '35px',
    width: '100%'
  };
}, Grid);
export var NavContainer = SideNav.NavContainer = useThemeDefaults(function () {
  return {
    display: ['none', 'none', 'block']
  };
}, Box);
export default SideNav;